function tryAutoFocus(el) {
  if (!el || el.disabled || typeof el.focus !== 'function') {
    return false;
  }

  const active = document.activeElement;
  const canTakeFocus =
    !active ||
    active === document.body ||
    active === document.documentElement ||
    active === el;

  if (!canTakeFocus) {
    return false;
  }

  el.focus({ preventScroll: true });

  try {
    const len = (el.value || '').length;
    if (typeof el.setSelectionRange === 'function') {
      el.setSelectionRange(len, len);
    }
  } catch {
    // Ignore unsupported input types.
  }

  return document.activeElement === el;
}

function runMicrotask(fn) {
  if (typeof queueMicrotask === 'function') {
    queueMicrotask(fn);
    return;
  }

  Promise.resolve().then(fn);
}

function scheduleFocus(el) {
  runMicrotask(() => {
    if (tryAutoFocus(el)) {
      return;
    }

    requestAnimationFrame(() => {
      if (tryAutoFocus(el)) {
        return;
      }

      setTimeout(() => {
        tryAutoFocus(el);
      }, 50);
    });
  });
}

export default {
  mounted(el) {
    scheduleFocus(el);
  },
  updated(el) {
    scheduleFocus(el);
  }
};